module.exports = __webpack_public_path__ + "static/media/lg-photo-shoot-drawing.900fd360.jpg";